import gql from "graphql-tag";

export const PARTNER_FIELDS = gql`
  fragment PartnerFields on Partner {
  partnerId
  name
  roles
  contactName
  email
  phone
  notes
  active
  addresses {
    addressId
    label
    type
    name
    attName
    phoneNr
    email
    addressLine1
    addressLine2
    postcode
    city
    stateProvince
    countryCode
  }
  insertedAt
  updatedAt
  }
`;

export const LIST_PARTNERS = gql`
  query partners($role: String, $active: Boolean) {
    partners(role: $role, active: $active) {
      ...PartnerFields
    }
  }
  ${PARTNER_FIELDS}
`;

export const GET_PARTNER = gql`
  query partner($partnerId: ID!) {
    partner(partnerId: $partnerId) {
      ...PartnerFields
    }
  }
  ${PARTNER_FIELDS}
`;

export const ON_PARTNER_UPDATED = gql`
  subscription onPartnerUpdated {
    partnerUpdated {
      id
    }
  }
`;
